import React, { useState } from 'react';
import { Form, Button, Alert, Card } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { db } from '../../config/firebase';
import { doc, setDoc } from 'firebase/firestore';

export default function Signup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    if (password !== confirmPassword) {
      return setError('Le password non coincidono');
    }

    try {
      setError('');
      setLoading(true);
      const cred = await signup(email, password, displayName);
      const userId = cred.user ? cred.user.uid : (cred.uid || null);
      if (userId) {
        await setDoc(doc(db, 'users', userId, 'profile', 'details'), {
          name: displayName,
          email: email,
          role: 'customer',
          createdAt: new Date().toISOString()
        });
      }
      navigate('/profile');
    } catch (error) {
      setError('Errore durante la registrazione: ' + error.message);
    }
    setLoading(false);
  }

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100">
      <Card className="w-100 rounded-4" style={{ maxWidth: '400px' }}>
        <Card.Body>
          <h2 className="text-center mb-4">Registrazione</h2>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Nome Utente</Form.Label>
              <Form.Control
                type="text"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                required
                className="rounded-pill"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="rounded-pill"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="rounded-pill"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Conferma Password</Form.Label>
              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="rounded-pill"
              />
            </Form.Group>
            <Button
              disabled={loading}
              className="w-100 rounded-pill"
              type="submit"
              variant="primary"
            >
              Registrati
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
} 